export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14034.87d5e7af.jpg";